export default __webpack_public_path__ + "static/media/left_down_icon.82ed130a.svg";